import React from "react";
import { TextField, Stack, Typography, Chip, Box } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";
export default function CharCountField({
  name,
  maxChar = 5000,
  maxSize = 6,
  variant = "outlined",
  label = "Note",
  isMandatoryLabel = false,
  required = false,
  showInfoChip = false,
  infoChipLabel = "",
  testId,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? { value: true, message: t("EmptyField") } : false,
      }}
      render={({ field, fieldState }) => {
        const error = fieldState.error || errors[name];
        const textValue = field.value || "";
        const handleChange = (e) => {
          const v = e.target.value;
          if (v.length <= maxChar) {
            field.onChange(v);
          }
        };

        return (
          <Stack mt={0} spacing={1}>
            {showInfoChip ? (
              <Box>
                <Chip
                  sx={{marginBottom: 1}}
                  icon={<BsInfoCircle color="white"/>}
                  label={t(infoChipLabel)}
                  className={"Mui-error"}
                />
              </Box>
            ) : null}
            <TextField
              {...field}
              label={t(label)}
              variant={variant}
              required={required}
              multiline
              minRows={maxSize}
              maxRows={maxSize}
              fullWidth
              value={textValue}
              onChange={handleChange}
              inputProps={{ maxLength: maxChar, ...(testId && { "data-testid": testId }) }}
              error={!!error}
              helperText={error?.message}
            />
            <Typography color="text.secondary" variant="caption">
              {textValue.length} / {maxChar}
            </Typography>
          </Stack>
        );
      }}
    />
  );
}
